<template>
  <b-container fluid>
    <b-form>
      <b-form-group>
        <b-form-textarea id="lock-so-dialog-note-input" v-model="note" placeholder="Note"></b-form-textarea>
      </b-form-group>
      <b-form-group>
        <b-button v-if="!this.locked" @click="lock">Lock</b-button>
        <b-button v-if="this.locked" @click="unlock">Unlock</b-button>
      </b-form-group>
    </b-form>
  </b-container>
</template>

<script>

import store from '@/store'

export default {
  name: 'LockSalesOrderOverlay',
  props: ['sono', 'closeMethod', 'locked'],
  data () {
    return {
      note: ''
    }
  },
  methods: {
    emptyNote () {
      this.$dlg.alert('A note is required to lock or unlock a sales order!', {
        language: 'en',
        messageType: 'error',
        width: 100,
        height: 50
      })
    },
    submitLock () {
      const payload = {
        'salesOrderNumber': this.sono.trim(),
        'locked': !this.locked,
        'note': this.note
      }
      store.dispatch('sales_orders/updateSalesOrderLocked', payload).then(() => {
        this.closeMethod()
      })
    },
    lock () {
      if (this.note.trim().length === 0) {
        this.emptyNote()
        return
      }
      this.submitLock()
    },
    unlock () {
      if (this.note.trim().length === 0) {
        this.emptyNote()
        return
      }
      this.submitLock()
    }
  }
}
</script>

<style scoped>
  #lock-so-dialog-note-input {
    height: 6em;
  }
</style>
